import { render, staticRenderFns } from "./MyFormulaLibraryDetail.vue?vue&type=template&id=37b5968c"
import script from "./MyFormulaLibraryDetail.vue?vue&type=script&lang=js"
export * from "./MyFormulaLibraryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports